import type { MailboxInfo } from 'owa-client-types';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import isMChatEnabled from './isMChatEnabled';
import { isAccountFeatureEnabled } from 'owa-feature-flags';

export function isDraftAssistantEnabled(mailboxInfo: MailboxInfo): boolean {
    // Coauthoring requires chat
    if (!isMChatEnabled(mailboxInfo)) {
        return false;
    }

    const isEnabled = isCopilotFeatureEnabled(
        'MailCoauthoring',
        mailboxInfo,
        true /*skipLanguageCheck */
    );

    return !!isEnabled && isAccountFeatureEnabled('mon-copilot-draft-assistant', mailboxInfo);
}
